export const wait = (ms = 500) => new Promise((r) => setTimeout(r, ms));
